import { EDocumentUploadType, zSchema } from "@zeal/common";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

/**
 * Shared base schema for ID upload link requests
 * Contains common fields used across all ID upload link routes
 */
export const baseIDUploadLinkSchema = zSchema.object({
  companyID: zSchema.string().min(1, "Company ID is required"),
  document_type: zSchema
    .array(zSchema.nativeEnum(EDocumentUploadType))
    .min(1, "At least one document type is required")
    .max(4, "Maximum 4 document types allowed"),
  send_to_worker: zSchema.boolean().default(false),
});

/**
 * Extended schema for public routes that includes testMode
 */
export const publicIDUploadLinkSchema = baseIDUploadLinkSchema.extend({
  testMode: zSchema.boolean().default(false),
});

export type TBaseIDUploadLinkRequest = zSchema.infer<
  typeof baseIDUploadLinkSchema
>;
export type TPublicIDUploadLinkRequest = zSchema.infer<
  typeof publicIDUploadLinkSchema
>;
export type TIDUploadLinkResponse = IApiResponse<string>;
